export const NO_COUNTRY_RESPONSE_STATUS = 467

export default (error) => error.status === NO_COUNTRY_RESPONSE_STATUS
